const TABLE_BORDER_RE = /^\+[-=+ ]+\+/;
const TABLE_ROW_RE = /^\|.*\|$/;
const LIST_RE = /^(\s{0,4})(\*|-) ([\s\S]*)$/;
const CODE_BLOCK_RE = /^\s*::$/;
const HEADING_RE = /^(#{1,3}) (.*)$/;
export function parseBlocks(input, options) {
    const lines = input.split('\n');
    const blocks = [];
    let i = 0;
    while (i < lines.length) {
        const line = lines[i];
        const trimmed = line.trimEnd();
        // Skip blank lines between blocks
        if (trimmed === '') {
            i++;
            continue;
        }
        // Table detection
        if (TABLE_BORDER_RE.test(trimmed) || TABLE_ROW_RE.test(trimmed)) {
            const tableLines = [];
            while (i < lines.length) {
                const tl = lines[i].trimEnd();
                if (tl === '' && tableLines.length > 0) {
                    // Blank line: check if next non-blank line is still table
                    const nextNonBlank = findNextNonBlank(lines, i);
                    if (nextNonBlank !== -1 && (TABLE_BORDER_RE.test(lines[nextNonBlank].trimEnd()) || TABLE_ROW_RE.test(lines[nextNonBlank].trimEnd()))) {
                        i++;
                        continue;
                    }
                    break;
                }
                if (TABLE_BORDER_RE.test(tl) || TABLE_ROW_RE.test(tl)) {
                    tableLines.push(lines[i]);
                    i++;
                }
                else {
                    break;
                }
            }
            blocks.push({ type: 'table', raw: tableLines.join('\n') });
            continue;
        }
        // Heading detection
        if (options?.enableHeadings) {
            const headingMatch = HEADING_RE.exec(trimmed);
            if (headingMatch) {
                blocks.push({
                    type: 'heading',
                    level: headingMatch[1].length,
                    text: headingMatch[2].trim(),
                });
                i++;
                continue;
            }
        }
        // Code block detection
        if (CODE_BLOCK_RE.test(trimmed)) {
            i++; // skip the :: line
            // Skip blank lines after ::
            while (i < lines.length && lines[i].trimEnd() === '') {
                i++;
            }
            const codeLines = [];
            while (i < lines.length) {
                const cl = lines[i];
                // Indented line: first char is space or tab
                if (cl.length > 0 && (cl[0] === ' ' || cl[0] === '\t')) {
                    // We could check whether the first non-whitespace char is *
                    // and we could break early...
                    // This was due to some weird edge case found in the wild
                    // But on second thought this doesn't make sense: we're still WITHIN
                    // the code block and so should ignore this the same way we do everythine else
                    // const firstNonWs = cl.search(/\S/);
                    // if (firstNonWs !== -1 && cl[firstNonWs] === '*') {
                    //   break; // list item, end code block
                    // }
                    codeLines.push(cl);
                    i++;
                }
                else if (cl.trimEnd() === '') {
                    // Blank line within code block - check if there's more indented content ahead
                    const nextNonBlank = findNextNonBlank(lines, i);
                    if (nextNonBlank !== -1 && lines[nextNonBlank].length > 0 &&
                        (lines[nextNonBlank][0] === ' ' || lines[nextNonBlank][0] === '\t')) {
                        // Check the next non-blank line's first non-ws char isn't *
                        const fnws = lines[nextNonBlank].search(/\S/);
                        if (fnws !== -1 && lines[nextNonBlank][fnws] === '*') {
                            break;
                        }
                        codeLines.push('');
                        i++;
                    }
                    else {
                        break;
                    }
                }
                else {
                    break;
                }
            }
            // Trim trailing empty lines from code content
            while (codeLines.length > 0 && codeLines[codeLines.length - 1].trimEnd() === '') {
                codeLines.pop();
            }
            if (codeLines.length > 0) {
                blocks.push({ type: 'codeBlock', content: codeLines.join('\n') });
            }
            continue;
        }
        // List detection
        if (LIST_RE.test(trimmed)) {
            const items = [];
            while (i < lines.length) {
                const ll = lines[i];
                const listMatch = LIST_RE.exec(ll.trimEnd());
                if (!listMatch)
                    break;
                const itemContent = listMatch[3];
                const continuations = [];
                i++; // move past the list item line
                // Collect continuation lines and blank lines
                let blankBuffer = 0;
                while (i < lines.length) {
                    const cl = lines[i];
                    const ct = cl.trimEnd();
                    if (ct === '') {
                        blankBuffer++;
                        i++;
                        continue;
                    }
                    // Check if next line is a new list item
                    if (LIST_RE.test(ct)) {
                        blankBuffer = 0;
                        break;
                    }
                    // Check if it's an indented continuation (starts with whitespace)
                    if (cl[0] === ' ' || cl[0] === '\t') {
                        // This is a continuation paragraph
                        if (blankBuffer > 0) {
                            // blank lines before continuation are fine
                            blankBuffer = 0;
                        }
                        continuations.push(cl.trimStart());
                        i++;
                        continue;
                    }
                    // Non-indented, non-list line -> end of list
                    break;
                }
                items.push({ content: itemContent, continuations });
            }
            blocks.push({ type: 'list', items });
            continue;
        }
        // Paragraph: collect lines until blank line or block-start
        const paraLines = [];
        while (i < lines.length) {
            const pl = lines[i];
            const pt = pl.trimEnd();
            if (pt === '')
                break;
            if (TABLE_BORDER_RE.test(pt) || TABLE_ROW_RE.test(pt))
                break;
            if (options?.enableHeadings && HEADING_RE.test(pt))
                break;
            if (CODE_BLOCK_RE.test(pt))
                break;
            if (LIST_RE.test(pt))
                break;
            paraLines.push(pl);
            i++;
        }
        blocks.push({ type: 'paragraph', text: paraLines.join('\n') });
    }
    return blocks;
}
function findNextNonBlank(lines, start) {
    for (let j = start; j < lines.length; j++) {
        if (lines[j].trimEnd() !== '')
            return j;
    }
    return -1;
}
